var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompareArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 7,
    viewBox: "0 0 27 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3.9641V6.9282L12 3.4641L6 0V2.9641H0V3.9641H6Z",
    fill: "#5E639B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 3.9641V6.9282L20 3.4641L14 0V2.9641H8V3.9641H14Z",
    fill: "#5E639B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 3.96411V6.92821L27 3.46411L21 9.51289e-06V2.96411H15V3.96411H21Z",
    fill: "#5E639B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareArrowIcon);
export default __webpack_public_path__ + "static/media/CompareArrowIcon.394a696e501cf1959b8fdf82c6aba624.svg";
export { ForwardRef as ReactComponent };